import { Box, Paper, Typography } from '@mui/material'

interface FareHighlightsStat {
    label: string
    value: string
    subtitle?: string
}

interface FareHighlightsProps {
    stats: FareHighlightsStat[]
}

const FareHighlights: React.FC<FareHighlightsProps> = ({ stats }) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)' },
                gap: { xs: 1, sm: 1.5 },
                mb: 3
            }}
        >
            {stats.map((stat, index) => (
                <Paper
                    key={index}
                    variant="outlined"
                    sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 2, bgcolor: 'background.paper' }}
                >
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500, display: 'block', mb: 0.5 }}>
                        {stat.label}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1.05rem' }, lineHeight: 1.2, wordBreak: 'break-word' }}
                    >
                        {stat.value}
                    </Typography>
                    {stat.subtitle && (
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.25, display: 'block' }}>
                            {stat.subtitle}
                        </Typography>
                    )}
                </Paper>
            ))}
        </Box>
    )
}

export default FareHighlights
export type { FareHighlightsProps, FareHighlightsStat }
